import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';

import LogoImg from '~/assets/icons/logo.webp';
import LanguageSelector from '~/components/organisms/language-selector/LanguageSelector';
import {
  StyledBottom,
  StyledBottomLink,
  StyledBottomLinkLogin,
  StyledContainer,
  StyledContent,
  StyledDrawer,
  StyledLanguageSwitcherContainer,
  StyledLink,
  StyledLinksWrapper,
  StyledLogo,
  StyledMenuButton,
  StyledMenuIcon,
  StyledTop,
} from '~/components/organisms/MobileDrawer/styled';
import { Text } from '~/components/ui/text';
import { PATH } from '~/constants/route-path';

const LINKS = [
  {
    title: 'common:services',
    links: [
      { label: 'common:createQrCodes', url: '#', isBorder: true, type: 'link' },
      { label: 'landing:footer.pricePlan', url: PATH.UNAUTH.PRICES_AND_PLANS, isBorder: true, type: 'link' },
      { label: 'common:language', isBorder: false, type: 'switcher' },
    ],
  },
  {
    title: 'landing:footer.company',
    links: [
      { label: 'landing:footer.tos', url: PATH.TOS, isBorder: true, type: 'link' },
      { label: 'landing:footer.privacy', url: PATH.UNAUTH.PRIVACY_POLICY, isBorder: false, type: 'link' },
    ],
  },
  {
    title: 'landing:footer.help',
    links: [
      { label: 'landing:footer.dataDeletion', url: PATH.UNAUTH.DATA_DELETION, isBorder: true, type: 'link' },
      { label: 'landing:footer.faq', url: PATH.UNAUTH.FAQ, isBorder: true, type: 'link' },
      { label: 'landing:footer.contact', url: PATH.UNAUTH.CONTACT_US, isBorder: false, type: 'link' },
    ],
  },
];

export default function MobileDrawer() {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  return (
    <>
      <StyledMenuButton aria-label="Menu" onClick={() => setOpen(true)}>
        <StyledMenuIcon />
      </StyledMenuButton>
      <StyledDrawer anchor="right" open={open} onClose={() => setOpen(false)} hideBackdrop>
        <StyledContainer>
          <StyledTop>
            <StyledLogo src={LogoImg} alt="logo" />
            <CloseIcon onClick={() => setOpen(false)} />
          </StyledTop>
          <StyledContent>
            <StyledLinksWrapper>
              {LINKS.map(({ title, links }) => {
                return (
                  <Fragment key={title}>
                    <Text variant="h3">{t(title)}</Text>
                    {links.map(({ label, url, isBorder, type }) => {
                      if (type === 'switcher') {
                        return (
                          <StyledLanguageSwitcherContainer key={label}>
                            <Text variant="t16Regular">{t(label)}</Text>
                            <LanguageSelector />
                          </StyledLanguageSwitcherContainer>
                        );
                      }

                      return (
                        <StyledLink key={label} to={url} $isBorder={isBorder}>
                          {t(label)}
                        </StyledLink>
                      );
                    })}
                  </Fragment>
                );
              })}
            </StyledLinksWrapper>
            <StyledBottom>
              <StyledBottomLink to={PATH.SIGN_UP}>{t('buttons:signUp')}</StyledBottomLink>
              <StyledBottomLinkLogin to={PATH.LOGIN}>{t('buttons:login')}</StyledBottomLinkLogin>
            </StyledBottom>
          </StyledContent>
        </StyledContainer>
      </StyledDrawer>
    </>
  );
}
